import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      title: 'RadioPharm: the database of radiopharmaceuticals (RPs)'
    }
  },
  {
    path: '/data/drug',
    name: 'data-drug',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataDrug.vue'),
    meta: {
      title: 'Radiopharmaceutical Information | RadioPharm'
    }
  },
  {
    path: '/data/radionuclide',
    name: 'data-radionuclide',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataRadionuclide.vue'),
    meta: {
      title: 'Radionuclide Information | RadioPharm'
    }
  },
  {
    path: '/data/linker',
    name: 'data-linker',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataLinker.vue'),
    meta: {
      title: 'Linker Information | RadioPharm'
    }
  },
  {
    path: '/data/chelator',
    name: 'data-chelator',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataChelator.vue'),
    meta: {
      title: 'Chelator Information | RadioPharm'
    }
  },
  {
    path: '/data/vector',
    name: 'data-vector',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataVector.vue'),
    meta: {
      title: 'Vector Information | RadioPharm'
    }
  },
  {
    path: '/data/target',
    name: 'data-target',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataTarget.vue'),
    meta: {
      title: 'Target Information | RadioPharm'
    }
  },
  {
    path: '/data/disease',
    name: 'data-disease',
    component: () => import(/* webpackChunkName: "about" */ '@/views/mianPage/DataDisease.vue'),
    meta: {
      title: 'Disease Information | RadioPharm'
    }
  },

  // {
  //   path: '/update-data-SR',
  //   name: 'update-data-SR',
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/UpdateDate.vue'),
  //   meta: {
  //     title: 'Update Data | RadioPharm'
  //   }
  // },


  // ----------------------------------------------------------------------------
  {
    path: '/search-drug-page',
    name: 'search-drug-page',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchPage/SearchDrugPage.vue'),
    meta: {
      title: 'Search for Radiopharmaceuticals | RadioPharm'
    }
  },
  {
    path: '/search-radionuclide-page',
    name: 'search-radionuclide-page',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchPage/SearchRadionuclidePage.vue'),
    meta: {
      title: 'Search for Radionuclide | RadioPharm'
    }
  },
  {
    path: '/search-target-page',
    name: 'search-target-page',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchPage/SearchTargetPage.vue'),
    meta: {
      title: 'Search for Target | RadioPharm'
    }
  },
  {
    path: '/search-disease-page',
    name: 'search-disease-page',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchPage/SearchDiseasePage.vue'),
    meta: {
      title: 'Search for Disease | RadioPharm'
    }
  },
  // ----------------------------------------------------------------------------
  {
    path: '/search-drug',
    name: 'search-drug',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchResult/SearchDrug.vue'),
    meta: {
      title: 'Radiopharmaceuticals Search Results | RadioPharm'
    }
  },
  {
    path: '/search-radionuclide',
    name: 'search-radionuclide',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchResult/SearchRadionuclide.vue'),
    meta: {
      title: 'Target Search Results | RadioPharm'
    }
  },
  {
    path: '/search-target',
    name: 'search-target',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchResult/SearchTarget.vue'),
    meta: {
      title: 'Target Search Results | RadioPharm'
    }
  },
  {
    path: '/search-disease',
    name: 'search-disease',
    component: () => import(/* webpackChunkName: "about" */ '@/views/searchResult/SearchDisease.vue'),
    meta: {
      title: 'Disease Search Results | RadioPharm'
    }
  },
  // ----------------------------------------------------------------------------




  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ContactView.vue'),
    meta: {
      title: 'Contact US | RadioPharm'
    }
  },
  {
    path: '/download',
    name: 'download',
    component: () => import(/* webpackChunkName: "about" */ '@/views/DownloadPage.vue'),
    meta: {
      title: 'Download Data | RadioPharm'
    }
  },

  {
    path: '/manual',
    name: 'manual',
    component: () => import(/* webpackChunkName: "about" */ '@/views/ManualPage.vue'),
    meta: {
      title: 'Manual | RadioPharm'
    }
  },  






  {
    path: '/to-be-available',
    name: 'to-be-available',
    component: () => import(/* webpackChunkName: "about" */ '../views/ToBeAvailable.vue'),
    meta: {
      title: 'To be available | RadioPharm'
    }
  },



]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
